import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import { createUIDefinition } from '../default-task-definition'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import { selectImageVersionList } from '../../../../customer/state/image/selector'

export default createUIDefinition({
    taskName: taskName.TAKE_PICTURES,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
            widgetProps: {
              skipImages: ['lower-row-of-teeth', 'upper-row-with-aligner', 'lower-row-with-aligner'],
            },
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.CUSTOMER_CONTACT_WIDGET,
        },
    ],
    taskValidatorSelector: [
        selectImageVersionList,
    ],
    taskValidator: (task, processInstance, taskName, eventName, imageVersionList) => {
        const messageList = []

        if (!imageVersionList || Object.keys(imageVersionList).length < 8) {
            messageList.push(createValidationMessage('Please take all pictures first.', 'validateThreeShapeCase'))
        }

        return messageList
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/in-shop-scan/take-pictures.js